export default __webpack_public_path__ + "static/media/fj.c531b1a2.svg";